/**
 * Banner text added to files that should not be edited by users.
 */
export const NON_EDITABLE_FILE_BANNER =
	"// Code generated by Prismic. DO NOT EDIT.";

export const CUSTOM_TYPES_LIBRARY_DIRNAME = "customtypes";

export const CUSTOM_TYPE_MODEL_FILENAME = "index.json";

export const SHARED_SLICE_MODEL_FILENAME = "model.json";

export const TSCONFIG_FILENAME = "tsconfig.json";

export const GLOBAL_TYPESCRIPT_TYPES_FILENAME = "prismicio-types.d.ts";
